class TcPhoneNumberController {
  constructor($element, $scope, $timeout) {
    "ngInject";
    this.$element = $element;
    this.$scope = $scope;
    this.$timeout = $timeout;
  }

  $onInit() {
    // Initialize if ngModel has a value
    if (this.ngModel) {
      this.formatPhoneNumber();
    }
  }

  $onChanges(changes) {
    if (changes.ngModel && this.ngModel) {
      this.$timeout(() => {
        this.formatPhoneNumber();
      });
    }
  }

  onInputChange() {
    // Format as user types
    this.formatPhoneNumber();
  }

  formatPhoneNumber() {
    if (!this.ngModel) {
      return;
    }

    // Remove all non-digit characters
    const cleaned = ('' + this.ngModel).replace(/\D/g, '');
    
    // If empty after cleaning, set to empty string
    if (!cleaned) {
      this.ngModel = '';
      return;
    }

    // Limit to 10 digits
    const digits = cleaned.substring(0, 10);

    // Format based on length
    let formatted = '';
    if (digits.length <= 3) {
      formatted = digits.length > 0 ? '(' + digits : '';
    } else if (digits.length <= 6) {
      formatted = '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
    } else {
      formatted = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
    }

    this.ngModel = formatted;
    
    // Update the input element value
    const inputElement = this.$element[0].querySelector('input');
    if (inputElement) {
      inputElement.value = formatted;
    }
  }

  isValidPhoneNumber() {
    if (!this.ngModel) {
      return !this.required; // Empty is valid if not required
    }
    
    const cleaned = ('' + this.ngModel).replace(/\D/g, '');
    return cleaned.length === 10;
  }
}

export default TcPhoneNumberController;




// WEBPACK FOOTER //
// ./client/common/directives/phone-number/tc-phone-number.controller.js